"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnv = function () {
    var host = window.location.hostname || '';
    var testEnv = host.indexOf('skype.net') !== -1;
    if (testEnv && (host.slice(0, 3) === 'pre' || host.slice(0, 3) === 'dev')) {
        return 'pre';
    }
    else if (testEnv && host.slice(0, 2) === 'qa') {
        return 'qa';
    }
    return 'live';
};
//# sourceMappingURL=getEnv.js.map